<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 5H4.16667H17.5" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path
        d="M15.8334 5.0013V16.668C15.8334 17.11 15.6578 17.5339 15.3453 17.8465C15.0327 18.159 14.6088 18.3346 14.1667 18.3346H5.83341C5.39139 18.3346 4.96746 18.159 4.6549 17.8465C4.34234 17.5339 4.16675 17.11 4.16675 16.668V5.0013M6.66675 5.0013V3.33464C6.66675 2.89261 6.84234 2.46868 7.1549 2.15612C7.46746 1.84356 7.89139 1.66797 8.33341 1.66797H11.6667C12.1088 1.66797 12.5327 1.84356 12.8453 2.15612C13.1578 2.46868 13.3334 2.89261 13.3334 3.33464V5.0013"
        :stroke-width="strokeWidth" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>

</template>

<script>
export default {
  name: 'TrashIcon',
  props: {
    strokeWidth: {type: String, default: '1.2'}
  }
}
</script>
